module.exports = __webpack_public_path__ + "alert-blocks.2bf0f720db86368e989a.svg";